import { graphql, useStaticQuery } from 'gatsby';
import { PolicyProps } from './policyQuery';

const privacyPolicyQuery = () => {
  const data = useStaticQuery(graphql`
    query PrivacyPolicyQuery {
      privacyPolicy: mdx(frontmatter: { page: { eq: "terms" } }) {
        id
        body
        excerpt
        tableOfContents
        frontmatter {
          title
          date(formatString: "MMMM DD, YYYY")
          page
          authors
          description
          category
          tags
          published
        }
        internal {
          contentFilePath
        }
      }
    }
  `);

  const privacyPolicy: PolicyProps = data.privacyPolicy;
  return { privacyPolicy };
};

export { privacyPolicyQuery };
